import type { ReactElement } from 'react';

// TODO Implement me
const Inline404 = (): ReactElement => <div>not found</div>;

export default Inline404;
